<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Warning
      </div>
      <button
        class="ac-close-button"
        type="button"
        @click="toggleModal(false)"
      >
        <img
          src="../../../assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      <div>Are you sure you want to delete this email</div>
    </div>
    <div class="ac-footer-container">
      <button
        class="ac-form-deactivate"
        type="button"
        @click="remove"
      >
        <span class="warning-settings">
          Delete
        </span>
      </button>
      <button
        class="ac-form-button"
        type="button"
        @click="cancel"
      >
        <span class="warning-settings">
          Cancel
        </span>
      </button>
    </div>
  </div>
</template>
<script>

export default {
  name: 'DeleteEmailWarning',
  props: {
    corpId: Number,
    firstName: String,
    lastName: String,
    toEmail: String,
    partnerSettings: Object,
    changes: Function,
    toggleActionModal: Function,
    onSubmit: Function,
  },
  data() {
    return {
      continue: false,
    };
  },
  methods: {
    cancel() {
      this.toggleActionModal(false);
    },
    async remove() {
      this.$store.dispatch('deleteChargebeeContact', this.corpId);
      this.toggleActionModal(false);
    },
  },
};
</script>

<style lang="scss">

.warning-settings {
  color: white;
  font-size: 14px;
  font-weight: bold;
}
</style>
